export enum UsersInsideAreaPresence {
  /** Currently inside the area. */
  INSIDE = 'INSIDE',
  /** Have entered the area at least once but their latest punch was an EXIT. */
  PAST = 'PAST',
  /** Both — currently inside + past visitors merged. */
  ALL = 'ALL',
}

export interface UserInsideArea {
  userId: string;
  fullName: string;
  email?: string | null;
  avatar?: string | null;
  role?: string | null;
  /** Time of the user's latest ENTER in this area. */
  entryTime: string | Date;
  /**
   * Inside users: minutes since `entryTime`.
   * Past visitors: length of their last visit (`exitTime - entryTime`).
   */
  durationMinutes: number;
  /** True when the user is currently inside. */
  isInside: boolean;
  /** Set only when the user is a past visitor — time of latest EXIT. */
  exitTime?: string | Date | null;
  projectId?: string | null;
  geofenceId?: string | null;
}

export interface UsersInsideAreaFilter {
  projectId?: string;
  geofenceId?: string;
  presence?: UsersInsideAreaPresence;
}
